import {BaseTOI} from "./BaseTOI";
import {TOPqm} from "./TOPqm";
import {BaseMuWidget} from "../BaseMuWidget";
import {BaseRouter} from "../BaseRouter";

export class TOIPqm extends BaseTOI {

    // @ts-ignore
    muParent: TOPqm;

    beforeIndex() {
        this.container.classList.add("ticket-overview__item", "ticket-overview--pqm__item");
        this.muAppendContent(`
 			<div class="icon-before-play field-created"><span mu-bind='dtCreate|dateTime("d.m.Y")'></span></div>
			<a mu-id="link1" mu-bind='evidenceUid;id|prepend("id "):title' class="field-evidenceUid icon-before-document-numbers"></a>
			<a mu-id="link2" mu-bind='summary;id|prepend("id "):title' class="field-summary icon-before-detail"></a>
            <div class="field-state">
                <div class="badge" mu-bind="stateName;stateColor:style.backgroundColor;stateColor|bwContrasted:style.color"></div></div>
            </div>
			<div title="Zadavatel" mu=':UiAccountList#roles|filterRole("customer")' class="field-customer icon-before-customer"></div>
			<div title="Řešitel" mu=':UiAccountList#roles|filterRole("solver")' class="field-solver icon-before-solver"></div>
			<div title="Kalendář" mu-bind="calItems:@foreach">
			    <div mu=":.@item" class="icon-before-calendar">
			        <span mu='#dtFrom|dateTime("d.m.Y");typeName:title'></span>
                </div>
            </div>
       `);
    }

    filterRole(data: any[], ev:any, roleCode: string) {
        return data.filter(a => a.roleCode === roleCode);
    }

    muBindData(srcData: any) {
        super.muBindData(srcData);
        this.srcData = srcData;
        this.getRouter().paTicket([
            this.container,
            this.ui.link1,
            this.ui.link2,
        ], srcData);
    }

    container_click() { }
}

export class UiAccountList extends BaseMuWidget {
    muBindData(srcData: any) {
        this.container.innerText = srcData.map(a => a.name).join(', ');
    }
}